"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { useState } from "react";
import { OrgFetchError } from "@/features/clerk/org-fetch";

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof OrgFetchError && error.status >= 400 && error.status < 500) {
    return false;
  }
  return failureCount < 1;
}

export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: shouldRetryQuery,
          },
        },
      }),
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
